import React, { useState, useEffect, Fragment } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import styles from '../styles.module.scss';

const InsuranceNetworkList = ({ insuranceNetworkData }) => {
  const [isTier, setIsTier] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [insuranceNetworkList, setInsuranceNetworkList] = useState([]);

  useEffect(() => {
    if (insuranceNetworkData) {
      setInsuranceNetworkList(insuranceNetworkData);
    }
  }, [insuranceNetworkData]);

  const insuranceNetworkOptions = insuranceNetworkList
    .filter(item => !item.isSelected)
    .map(item => ({ value: item.id, label: item.name }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const insuranceNetworks = insuranceNetworkList
    .filter(item => item.isSelected)
    .sort((a, b) => a.name.localeCompare(b.name));

  const customStyles = {
    control: () => ({
      border: '1px solid #727069',
      borderRadius: '4px',
      display: 'flex',
      height: '30px',
      width: '300px'
    }),
    indicatorSeparator: () => ({
      display: 'none'
    })
  };

  const handleSelectedOption = selectedOption => {
    setSelectedOption(selectedOption);
  };

  const handleChangeTier = event => {
    setIsTier(event.target.checked);
  };

  const handleAddInsuranceNetwork = () => {
    if (!selectedOption) return;

    const updatedInsuranceNetworkList = insuranceNetworkList.map(item => ({
      ...item,
      tierFlag: item.id === selectedOption.value ? (isTier ? 'Y' : 'N') : item.tierFlag,
      isSelected: item.id === selectedOption.value || item.isSelected
    }));

    setInsuranceNetworkList(updatedInsuranceNetworkList);
    setSelectedOption(null);
    setIsTier(false);
  };

  const handleRemoveInsuranceNetwork = network => {
    const updatedInsuranceNetworkList = insuranceNetworkList.map(item => ({
      ...item,
      tierFlag: item.id === network.id ? 'N' : item.tierFlag,
      isSelected: item.id === network.id ? false : item.isSelected
    }));

    setInsuranceNetworkList(updatedInsuranceNetworkList);
  };

  const handleUpdateNetworkTier = (event, network) => {
    const updatedInsuranceNetworkList = insuranceNetworkList.map(item => ({
      ...item,
      tierFlag: item.id === network.id ? (event.target.checked ? 'Y' : 'N') : item.tierFlag
    }));

    setInsuranceNetworkList(updatedInsuranceNetworkList);
  };

  const renderNameForKey = (key, index) =>
    `product_manager[service_specialties[primary_care]][insurance_networks][${index}][${key}]`;

  return (
    <Fragment>
      <h4>Insurance Networks</h4>
      <table>
        <thead>
        <tr>
          <th className={styles.networkName}>Name</th>
          <th>Network Tiering</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        {insuranceNetworks.map((network, index) => (
          <tr key={`network-${network.id}`} className='insurance_network_item'>
            <td>
              {network.name}
              <input
                value={network.id}
                className='insurance_networks_id'
                type='hidden'
                name={renderNameForKey('insurance_network_id', index)}
              />
              <input
                value={network.name}
                className='insurance_networks_name'
                type='hidden'
                name={renderNameForKey('name', index)}
              />
            </td>
            <td>
              <input
                id='group_network_tier'
                value={network.tierFlag ? 'Y' : 'N'}
                type='checkbox'
                onChange={(event) => handleUpdateNetworkTier(event, network)}
                name={renderNameForKey('tiering_flg', index)}
                checked={network.tierFlag === 'Y'}
              />
            </td>
            <td>
              <a className='button_remove_network' onClick={() => handleRemoveInsuranceNetwork(network)}>Remove</a>
            </td>
          </tr>
        ))}

        <tr>
          <td>
            <Select
              id='network_search'
              isSearchable='true'
              options={insuranceNetworkOptions}
              value={selectedOption}
              onChange={handleSelectedOption}
              styles={customStyles}
              placeholder='Select an Insurance Network'
            />
          </td>
          <td>
            <input
              id='group_network_tier_flag'
              type='checkbox'
              onChange={handleChangeTier}
              checked={isTier}
            />
          </td>
          <td>
            <button className='button' onClick={handleAddInsuranceNetwork} type='button'>Add</button>
          </td>
        </tr>
        </tbody>
      </table>
      <br />
    </Fragment>
  );
};

InsuranceNetworkList.propTypes = {
  insuranceNetworkData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      tierFlag: PropTypes.string,
      isSelected: PropTypes.bool
    })
  )
};

export default InsuranceNetworkList;
